import {PlayClass} from "../../models/class-structure/generic/PlayClass";
import {PianoSectionClassController} from "./PianoSectionClassController";

export class PianoSingleSectionPartClassController extends PianoSectionClassController {
  constructor(playClass: PlayClass) {
    if (playClass.containedClasses.length > 1) {
      console.error('this class in not made for Part that contains more than one section');
    }
    super(playClass.containedClasses[0], playClass);
  }
}
